module.exports = __webpack_public_path__ + "img/history_check_empty.dc29f3bb.png";